module.exports = __webpack_public_path__ + "static/img/step5.52b1b84.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/howto/step5.png
// module id = j+rW
// module chunks = 1